export const IS_PROD = process.env.NEXT_PUBLIC_IS_PROD === "true";

// Application constants
export const TELEGRAM_BOT_NAME = "SpicenetBot";

// API endpoints
export const ENDPOINTS = {
  auth: "/auth",
  challenges: "/challenges",
  users: "/users",
  communities: "/communities",
};

// Local storage keys
export const STORAGE_KEYS = {
  taskGuid: "taskGuid",
  taskName: "taskName",
  referralCode: "pending_referral_code",
};
